import * as hf from './_hf';
import * as ht from './_ht';

export const f = (
  date: Date | ht.s,
  stl?: ht.s,
  bPdg?: ht.b,
): string => {
  const _dtm = new Date(date);
  const _YYYY = _dtm.getFullYear();
  let _MM = String(_dtm.getMonth() + 1); //１を足すこと
  if (Number(_MM) < 10) {
    _MM = bPdg != false ? ('0' + _MM) : (' ' + _MM);
  }
  let _DD = String(_dtm.getDate());
  if (Number(_DD) < 10) {
    _DD = bPdg != false ? ('0' + _DD) : (' ' + _DD);
  }
  let _hh = String(_dtm.getHours());
  if (Number(_hh) < 10) {
    _hh = '0' + _hh;
  }
  let _mm = String(_dtm.getMinutes());
  if (Number(_mm) < 10) {
    _mm = '0' + _mm;
  }
  let _ss = String(_dtm.getSeconds());
  if (Number(_ss) < 10) {
    _ss = '0' + _ss;
  }
  switch (stl) {
    case '年月日（曜日）':
      return `${_YYYY}年${_MM}月${_DD}日（${cvtDow(date)}曜日）`;
    case '年月日（曜）':
      return `${_YYYY}年${_MM}月${_DD}日（${cvtDow(date)}）`;
    case '年月日':
      return `${_YYYY}年${_MM}月${_DD}日`;
    case '年月':
      return `${_YYYY}年${_MM}月`;
    case '月':
      return `${_MM}月`;
    case '月日':
      return `${_MM}月${_DD}日`;
    case '月日時分':
      return `${_MM}月${_DD}日${_hh}時${_mm}分`;
    case '日（曜）':
      return `${_DD}日（${cvtDow(date)}）`;
    case '時分':
      return `${_hh}時${_mm}分`;
    case 'YYYY':
      return `${_YYYY}`;
    case 'YYYYMM':
      return `${_YYYY}${_MM}`;
    case 'YYYYMMDD':
      return `${_YYYY}${_MM}${_DD}`;
    case 'YYYY-MM':
      return `${_YYYY}-${_MM}`;
    case 'YYYY-MM-DD':
      return `${_YYYY}-${_MM}-${_DD}`;
    case 'YYYY-MM-DD hh:mm:ss':
      return `${_YYYY}-${_MM}-${_DD} ${_hh}:${_mm}:${_ss}`;
    case 'YYYYMMDDhhmmss':
      return `${_YYYY}${_MM}${_DD}${_hh}${_mm}${_ss}`;
    case 'hh:mm':
      return `${_hh}:${_mm}:`;
    case 'hh':
      return `${_hh}`;
    default:
      //hf.l(`hfDTM 37: incorrect stl ${stl}`);
      return `${_YYYY}-${_MM}-${_DD}`;
  }
};

export const addMnt = (
  pDtm: ht.s,
  pnMnt: ht.n,
  fmt?: ht.s,
): ht.s => {
  const _dtm = new Date();
  _dtm.setTime(Date.parse(`${String(pDtm).substring(0, 10)}T${String(pDtm).substring(11)}`) + pnMnt * 60000)
  return f(_dtm, fmt ?? 'YYYY-MM-DD');
};

export const addHour = (
  pDtm: ht.s,
  pnHour: ht.n
): ht.s => {
  const _dtm = new Date();
  _dtm.setTime(Date.parse(`${String(pDtm).substring(0, 10)}T${String(pDtm).substring(11)}`) + pnHour * 3600000)
  return f(_dtm);
};

export const addDay = (
  pDtm: ht.s,
  pnVle: ht.n
): ht.s => {
  const _dtm = new Date(pDtm);
  _dtm.setDate(_dtm.getDate() + pnVle);
  return f(_dtm);
};

export const addMth = (
  pDtm: ht.s,
  pnVle: ht.n
): ht.s => {
  const _dtm = new Date(pDtm);
  _dtm.setMonth(_dtm.getMonth() + pnVle);
  return f(_dtm);
};

export const addYear = (
  pDtm: ht.s,
  pnVle: ht.n,
): ht.s => {
  const _dtm = new Date(pDtm);
  _dtm.setMonth(_dtm.getMonth() + pnVle * 12);
  return f(_dtm);
};

export const bwn = ( // between
  dtm: ht.s,
  dtmStt: ht.s,
  dtmEnd: ht.s, // dtmEnd は含まない
) => {
  if (dtm >= dtmStt && dtm < dtmEnd) return true
  return false;
};

export const cvt24 = (
  dtm: ht.s,
) => {
  const _date = dtm.substring(0, 10);
  const _time = dtm.substring(11, 19);
  if (!_time) {
    return _date;
  }
  else {
    //hf.l(`hfDTM 58: ${dtm}, ${_date}, ${_time}`);
    let _dtm = `${_date} 23:${_time.substring(3, 8)}`;
    //hf.l(`hfDTM 60: ${_dtm}`);
    const _nHH = Number(_time.substring(0, 2));
    //hf.l(`hfDTM 62: ${_nHH}`);
    _dtm = addMnt(_dtm, (_nHH - 23) * 60);
    //hf.l(`hfDTM 64: ${_dtm}`);
    return _dtm;
  }
};

export const cvtCdrDates = (
  pDtm: ht.s,
) => {
  const _dtm = new Date(pDtm);
  const _fstDate = cvtFdm(_dtm);
  const _lastDate = cvtLdm(_dtm);
  const _nLastDay = cvtDay(_lastDate);
  return Array.from(hf.getRng(
    _nLastDay + (6 - cvtDowNbr(_lastDate)),
    1 - cvtDowNbr(_fstDate)
  )).map(_n_day => addDay(_fstDate, _n_day - 1));
};

export const cvtCeilHour = (
  pDtm: ht.s,
  pnHour: ht.n
) => {
  const _nHour = hf.cvtCeil(hf.n(String(pDtm).substring(11, 13)) / pnHour) * pnHour;
  const _org = `${String(pDtm).substring(0, 10)}T00:00:00`;
  return addHour(_org, _nHour);
};

export const cvtFlrHour = (
  pDtm: ht.s,
  pnHour: ht.n
) => {
  const _nHour = hf.cvtFlr(hf.n(String(pDtm).substring(11, 13)) / pnHour) * pnHour;
  const _org = `${String(pDtm).substring(0, 10)}T00:00:00`;
  return addHour(_org, _nHour);
};

export const cvtCeilMnt = (
  pDtm: ht.s,
  pnMnt: ht.n
) => {
  const _mnt = hf.cvtCeil(hf.n(String(pDtm).substring(14, 16)) / pnMnt) * pnMnt;
  const _org = `${String(pDtm).substring(0, 10)}T${String(pDtm).substring(11, 13)}:00:00`;
  return addMnt(_org, _mnt);
};

export const cvtFlrMnt = (
  pDtm: ht.s,
  pnMnt: ht.n
) => {
  const _mnt = hf.cvtFlr(hf.n(String(pDtm).substring(14, 16)) / pnMnt) * pnMnt;
  const _org = `${String(pDtm).substring(0, 10)}T${String(pDtm).substring(11, 13)}:00:00`;
  return addMnt(_org, _mnt);
};

export const cvtDates = (
  dateStt: ht.s,
  dateEnd: ht.s
) => {
  const _cnt = getDrcDay(dateStt, dateEnd) + 1;
  return hf.getRng(_cnt).map(_dff => addDay(dateStt, _dff - 1));
};

export const cvtDay = (
  pDtm: ht.s,
): ht.n => {
  const _dtm = new Date(pDtm);
  return Number(f(_dtm).substring(8, 10));
};

export const cvtDow = ( // day of the week
  dtm: Date | ht.s,
) => {
  return ["日", "月", "火", "水", "木", "金", "土"][cvtDowNbr(dtm)];
};

export const cvtDowNbr = ( // day of the week number
  dtm: Date | ht.s,
) => {
  const _dtm = new Date(dtm);
  return _dtm.getDay();
};

export const cvtFdm = (
  pDtm: Date | ht.s
) => {
  let _dtm = new Date(pDtm);
  _dtm = new Date(_dtm.getFullYear(), _dtm.getMonth(), 1); // 今月末
  return f(_dtm);
};

export const cvtLdm = (
  pDtm: Date | ht.s
) => {
  let _dtm = new Date(pDtm);
  _dtm = new Date(_dtm.getFullYear(), _dtm.getMonth() + 1, 0); // 今月末
  return f(_dtm);
};

export const cvtMth = (
  pDtm: Date | ht.s
) => {
  const _dtm = new Date(pDtm);
  return Number(f(_dtm).substring(5, 7));
};

export const cvtMthDates = (
  pDtm: Date | ht.s,
  dayStt?: ht.n,
  dayEnd?: ht.n,
) => {
  const _dtm = new Date(pDtm);
  const _fdm = dayStt ? addDay(cvtFdm(_dtm), dayStt - 1) : cvtFdm(_dtm);
  const _ldm = dayEnd ? addDay(cvtFdm(_dtm), dayEnd - 1) : cvtLdm(_dtm);
  const _nDayCnt = cvtDay(_ldm) - cvtDay(_fdm) + 1;
  return hf.getRng(_nDayCnt).map((_nDay: ht.n) => addDay(_fdm, _nDay - 1))
};

/*
export const cvtYearMth = (
  pDtm: ht.s
) => {
  const _dtm = new Date(pDtm);
//  return f(_dtm).substring(0, 7);
  return f(_dtm).substring(0, 7);
}

export const cvtYearMthDayDow = (
  pDtm: ht.s
) => {
  const _dtm = new Date(pDtm);
  return _dtm.toLocaleDateString("ja-JP", {
    year: "numeric", 
    month: "long", 
    day: "numeric", 
    weekday: "short", 
  });
}
*/

export const cvtYear = (
  dtm: Date | ht.s
) => {
  const _dtm = new Date(dtm);
  return Number(f(_dtm).substring(0, 4));
};

export const getDrcMth = ( // 日付単位の比較は行なっていない
  dtm1: ht.s,
  dtm2: ht.s,
) => {
  const _dtm3 = f(dtm2, 'YYYY-MM') + '-' + f(dtm1, 'DD');
  const _mth1 = cvtYear(dtm1) * 12 + cvtMth(dtm1);
  const _mth2 = cvtYear(dtm2) * 12 + cvtMth(dtm2);
  if (dtm2 >= _dtm3 ) {
    return _mth2 - _mth1;  
  }
  else {
    return _mth2 - _mth1 - 1;
  }
};

export const getDrcDay = ( // difference 日単位
  pDtm1: ht.s,
  pDtm2: ht.s
) => {
  const _dtm1 = new Date(String(cvt24(pDtm1)).replace(' ', 'T'));
  //hf.l(`hfDTM 198: ${_dtm1}`);
  const _dtm2 = new Date(String(cvt24(pDtm2)).replace(' ', 'T'));
  //hf.l(`hfDTM 200: ${_dtm2}`);
  return (_dtm2.getTime() - _dtm1.getTime()) / 86400000 ?? 0;
};

export const getDrcHour = ( // difference 時間単位
  dtm1: ht.s,
  dtm2: ht.s
) => {
  const _dtm1 = new Date(String(cvt24(dtm1)).replace(' ', 'T'));
  const _dtm2 = new Date(String(cvt24(dtm2)).replace(' ', 'T'));
  return (_dtm2.getTime() - _dtm1.getTime()) / 3600000 ?? 0;
};

export const getDrcMnt = ( // difference 分単位
  dtm1: ht.s,
  dtm2?: ht.s
) => {
  //  const _dtm1 = new Date(String(cvt24(dtm1)).replace(' ', 'T'));
  //  const _dtm2 = new Date(String(cvt24(dtm2 ?? getNow())).replace(' ', 'T'));
  const _dtm1 = new Date(dtm1);
  const _dtm2 = new Date(dtm2 ?? getNow());
  //hf.l(`hfDTM 285: ${_dtm1} ${_dtm2}`)
  return (_dtm2.getTime() - _dtm1.getTime()) / 60000 ?? 0; // ミリ秒を変換、端数切り捨て
};

export const getDrcScd = ( // difference 秒単位
  pDtm1: ht.s,
  pDtm2: ht.s
) => {
  const _dtm1 = new Date(String(cvt24(pDtm1)).replace(' ', 'T'));
  const _dtm2 = new Date(String(cvt24(pDtm2)).replace(' ', 'T'));
  return (_dtm2.getTime() - _dtm1.getTime()) / 1000 ?? 0; // ミリ秒を変換、端数切り捨て
};

export const getDrc = ( // difference 秒単位
  pDtm1: ht.s,
  pDtm2: ht.s
) => {
  const _dtm1 = new Date(pDtm1);
  const _dtm2 = new Date(pDtm2);
  return (_dtm2.getTime() - _dtm1.getTime()) ?? 0; // ミリ秒を変換、端数切り捨て
};

export const getNthDowDate = ( // date が属する月の、第 week 回目の dow 曜日
  date: ht.s,
  week: ht.n,
  dow: ht.n
) => {
  const _fdm = cvtFdm(date);
  const _fdmDow = cvtDowNbr(_fdm);
  let _drc = dow - _fdmDow; // difference
  if (dow < _fdmDow) _drc = 7 - (_fdmDow - dow);
  const _fstDowDate = addDay(_fdm, _drc);
  const _tgtDowDate = addDay(_fstDowDate, 7 * (week - 1))
  return _tgtDowDate;
}

export const getNthDowDates = ( // sttDate から endDate までの 第 week 回目の dow 曜日の一覧
  dateStt: ht.s,
  dateEnd: ht.s,
  week: ht.n,
  dow: ht.n,
) => {
  const _dates = [];
  if (hf.f(dateStt) && hf.f(dateEnd) && week > 0 && dow >= 0) {
    let _date = cvtFdm(dateStt);
    while (_date <= dateEnd) {
      const _dateTgt = getNthDowDate(_date, week, dow);
      if (_dateTgt >= dateStt && _dateTgt <= dateEnd) {
        _dates.push(_dateTgt);
      }
      _date = addMth(_date, 1);
    }
  }
  return _dates;
}

export const getNow = (): ht.s => {
  const _dtm = new Date();
  return f(_dtm, 'YYYY-MM-DD hh:mm:ss');
};

export const getTdy = (): ht.s => {
  const _dtm = new Date();
  return f(_dtm);
};

export const grtDates = (
  dateStt: ht.s,
  dateEnd: ht.s,
) => {
  const _nDays = getDrcDay(dateStt, dateEnd) + 1;
  const _ls = hf.getRng(_nDays).map((_nCnt: ht.n) => addDay(dateStt, _nCnt - 1));
  return _ls;
};
export const getDates = grtDates; // 廃止予定

export const grtYearMth = (
  year: ht.s | ht.n,
  mth: ht.s | ht.n,
) => {
  return `${year}-${hf.pdg(mth, 2, '0')}`
}

/*
export const fmtDtm = ( // f への統合を検討
  dtm: Date | ht.s,
  stl?: ht.s,
): string => {
  const _dtm = new Date(dtm);
  const _YYYY = _dtm.getFullYear();
  let _MM = String(_dtm.getMonth() + 1); //１を足すこと
  if (Number(_MM) < 10) {
    _MM = '0' + _MM;
  }
  let _DD = String(_dtm.getDate());
  if (Number(_DD) < 10) {
    _DD = '0' + _DD;
  }
  let _hh = String(_dtm.getHours());
  if (Number(_hh) < 10) {
    _hh = '0' + _hh;
  }
  let _mm = String(_dtm.getMinutes());
  if (Number(_mm) < 10) {
    _mm = '0' + _mm;
  }
  let _ss = String(_dtm.getSeconds());
  if (Number(_ss) < 10) {
    _ss = '0' + _ss;
  }
  switch (stl) {
    case '時分':
      return `${_hh}時${_mm}分`;
    default:
      return `${_YYYY}-${_MM}-${_DD} ${_hh}:${_mm}:${_ss}`;
  }
};
*/

/*
 Copyright 2020 Yukio Shinohara All rights reserved.
 */
